export default {
  Language: "中文",
  navbar: {
    homeFormat: "首页",
    warehouseFormat: "倉庫",
    wineFormat: "葡萄酒",
    contactFormat: "聯絡我們",
    sellwinesFormat: "出售你的葡萄酒",
  },
  home: {
    swiperTextFormat: "您只需細心品嚐！",
    swiperTextFormat2: "找酒的事，",
    swiperTextFormat3: " 就交給我們！",
    swiperBtnFormat: "美味的酒",
    contactModel: {
      titleFormat: "關於我們",
      contentFormat:
        "我們是一群喜愛喝酒，對休閒生活充滿熱情的同好。我們樂於自己尋找喜愛的酒類。 所以，我們開始提供給喜愛喝酒的同好，並給予多元及好的服務給我們的消費者， 於是 LeapflyWine 就誕生了。",
      contentFormat2:
        "當您在忙碌的工作結束後，在睡前或晚餐後，想要來一杯犒賞自己。 這個時候，您只需要從冰櫃拿出一瓶 LeapflyWine 的酒，絕對能滿足您的味蕾及喜好。",
      btnFormat: "了解更多",
    },
    teamModel: {
      titleFormat: "優秀的團隊",
      contentFormat: "我們的團隊具備豐富的實務經驗，更重視顧客的需求，而我們的理想，就是以優異的品質，來征服顧客的味蕾。",
    },
    exclusiveModel: {
      titleFormat: "專屬顧問",
      contentFormat:
        "我們知道每位顧客有不同酒類喜好，而當您購買後，我們會記錄您喜愛的酒項，並提供您建議，有任何疑問，歡迎您在上班時間，透過 Email 連絡我們我們會請專屬顧問團隊服務您。",
      contentFormat2: "我們的顧問團隊將提供您保存酒的基本觀念及酒項購買指南，迅速建立應有的基本概念，協助您在品酒過程中，能更享受。",
    },
  },
  wines: {
    inputplaceholder1: "請輸入內容",
    inputplaceholder2: "價格開始範圍",
    inputplaceholder3: "價格結束範圍",
    allIn: "全選",
    filterOptions: {
      yearFormat: "年份",
      countryFormat: "國家",
      areaFormat: "產區",
      specificationsFormat: "規格",
      typeFormat: "類型",
    },
    tableFormat: {
      chFormat: "中文名",
      enFormat: "英文名",
      yearFormat: "年份",
      typeFormat: "類型",
      specificationsFormat: "規格",
      countryFormat: "國家",
      areaFormat: "產區",
      priceFormat: "價格",
    },
  },
  contact: {
    contactFromFormat: {
      titleFormat: "聯絡我們",
      contentFormat: " 我們相當重視您的意見，若您有任何疑問，請填妥以下資料，我們會在近期與您聯繫。",
    },
    mapTitleFormat: "美酒相伴的美好時光",
    mapTextFormat:
      "公司简介：力發贸易有限公司坐落于中国澳门，成立于2021年，是一家专注于进口葡萄酒的知名酒类企业。我们的创始人是一群热爱葡萄酒的行业资深人士，他们在酒类领域打拼多年，结识了众多优质酒庄代表和同行业精英。 我们的产品保证品质优良，大部分直接从原产地采购，保持原汁原味；其余产品由行业内合作伙伴提供。我们以热情周到的服务著称，始终秉承认真负责的态度，竭尽全力为客户和合作伙伴解决问题，确保他们满意。公司秉持“诚信经营，互利共赢”的经营理念，不断优化经营体系，推动创新发展，并充分挖掘互联网线上销售的巨大潜力。",
    formFormat: {
      nameFormat: "姓名",
      namePlaceholder: "請輸入姓名",
      namePassed: "姓名輸入正確",
      phoneFormat: "電話",
      phonePlaceholder: "請輸入電話",
      phonePassed: "电话輸入正確",
      emailFormat: "電子郵件",
      emailPlaceholder: "請輸入 Email",
      emailPassed: "Email 輸入正確",
      contentFormat: "留言",
      contentPlaceholder: "若對酒類商品有疑問，請留言告訴我們",
      contentPassed: "已輸入意見",
      privacyMsg: "我同意隱私權政策，並同意依隱私權政策中所述的方式處理自己的資料",
      privacyMsgPlaceholder: "隱私權爲必填",
      privacyPassed: "已勾選",
    },
    submitFormat: {
      btnFormat: "確認送出",
    },
  },
  sellwines: {
    sellwinesFromFormat: {
      titleFormat: "将您的清单发送给我们",
      contentFormat:
        "作为主要股东，LeapflyWine 总是热衷于购买储存良好的私人收藏品，无论是在私人酒窖中缴纳关税，还是在专业仓库中保税。收到葡萄酒清单后，我们很乐意提供逐个葡萄酒的购买报价，并根据协议，在领取/收到和检查葡萄酒后立即付款。您的葡萄酒清单可以通过此页面上的链接上传，也可以直接通过电子邮件发送给我们",
    },
    formFormat: {
      nameFormat: "姓名",
      namePlaceholder: "請輸入姓名",
      namePassed: "姓名輸入正確",
      phoneFormat: "電話",
      phonePlaceholder: "請輸入電話",
      phonePassed: "电话輸入正確",
      emailFormat: "電子郵件",
      emailPlaceholder: "請輸入 Email",
      emailPassed: "Email 輸入正確",
      contentFormat: "关于您的葡萄酒",
      contentPlaceholder: "关于您的葡萄酒",
      contentPassed: "已輸入意見",
      privacyMsg: "我同意隱私權政策，並同意依隱私權政策中所述的方式處理自己的資料",
      privacyMsgPlaceholder: "隱私權爲必填",
      privacyPassed: "已勾選",
      uploadMsg: "上传您的酒单* 上传您现有的 Excel 列表以开始使用。",
    },
    submitFormat: {
      uploadBtnFormat: "上传",
      btnFormat: "確認送出",
    },
  },
  warehouse: {
    titleFormat: "美酒相伴的美好時光",
    contentFormat: ` 2020年8月，LeapflyWine 開設第一間網路商店。`,
		contentFormat2: `LeapflyWine 的成立為消費者注入更多元化的色彩及從二十多個國家採購洋酒，提供給我們的消費者。`,
		contentFormat3: `LeapflyWine 的貨倉，均設有二十四小時恒溫及濕度控制，確保所有餐酒在交到顧客手上之前，均獲得妥善的保存。`,
		contentFormat4: `LeapflyWine 的成員均須修畢國際認可的洋酒課程(Wine & Spirit Education Trust)， 讓他們能掌握各餐酒的背景資料和特性，以便向客人介紹。`,
	},
  footer: {
    contactFormat: {
      titleFormat: "联系我们",
    },
    addressFormat: {
      titleFormat: "地址",
      addressInFormat: "力發贸易有限公司",
      addressInFormat2: "澳門南灣大馬路762-804號14樓S室",
      icpFormat: "ICP备案号:粤ICP备2022091707号",
    },
  },
};
